import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'pobble-components/dist/setup/sentry'

import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import App from './components/app/app'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer'
import { requestMiddleware } from 'pobble-components/dist/redux-helpers'
import { ConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

import 'normalize.css'
import { apiGetMe } from './common/api/profile'
import { PobbleStyles } from 'pobble-components/dist/styles'
import { PostHogProvider } from 'posthog-js/react'
import { posthog } from 'posthog-js'

window.posthog = posthog

const store = createStore(
  rootReducer,
  applyMiddleware(requestMiddleware, thunk)
)

const posthogOptions = {
  api_host: 'https://eu.posthog.com',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: true
}

const render = ({ me, meError }) => {
  ReactDOM.render(
    <PostHogProvider
      apiKey="phc_m6fAJjfR7jb7zKLkCtHOehLuDegky6k0xbDfdYxnWqs"
      options={posthogOptions}>
      <Provider store={store}>
        <PobbleStyles>
          <Fragment>
            <App me={me} meError={meError} />
            <ConfirmationDialog />
          </Fragment>
        </PobbleStyles>
      </Provider>
    </PostHogProvider>,
    document.getElementById('root')
  )
}

apiGetMe({
  include:
    'account.timestamps,account.signup_details,account.subscriptions,account.subscription_policy,account.subscription_prices,account.subscription_currency,account.names,account.finish_signup_status,account.policy,account.pobbler_type,account.avatar,account.teacher_type.school,account.teacher_type.school.names,account.teacher_type.school.urn,account.email_identity.email,account.newsletter,account.student_type.school,account.pending_teacher_type,account.pending_teacher_type.details,account.pending_teacher_type.school,account.teacher_type.status'
}).then(res => render({ me: res }), e => render({ meError: e }))

// Lazy load external tools
setTimeout(() => import('pobble-components/dist/setup/external-tools'), 1000)
